export default __webpack_public_path__ + "static/media/favicon.d5b55242.ico";